<div class="theme_bg">
<div class="container">
    <div class="row" *ngIf="hotel && hotel.HotelName">
        <div class="col-md-8 col-lg-8">
            <div class="comon_backbg mb-4 mt-5">
                <div class="card-body pb-3">
                    <div class="row">
                        <div class="col-md-12 col-lg-12">
                            <h5 class="cusromGrey"><strong>{{hotel.HotelName}}</strong> </h5>
                            <ng-template *ngIf="hotel.StarRating === '' then noStar; else stars">
                            </ng-template>
                            <ng-template #noStar>
                                <span class="star_rtng">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </span>
                            </ng-template>
                            <ng-template #stars>
                                <span class="star_rtng">
                                    <i class="fas fa-star star_rtng_clr"
                                        *ngFor="let s of hotel.StarRating | map: getStarArray"></i>
                                    <i class="fas fa-star"
                                        *ngFor="let s of hotel.StarRating | map: getStarArrayRemaining"></i>
                                </span>
                            </ng-template>
                            <p class="cusromGrey mt-2">

                                {{hotel.HotelAddress}}
                            </p>
                            <p class="cusromGrey mt-3" style="margin-bottom: 15px; font-size:14px;">
                                <strong>
                                    {{'Cancellation Policy:'}}
                                </strong>
                                <span class="" [innerHTML]="hotel.CancellationPolicy">
                                </span>
                            </p>
                            <p class="cusromGrey" style="margin-bottom: 15px; font-size:14px;">
                                <strong>
                                    {{'Remarks:'}}
                                </strong>
                                <span class=""> {{hotel.Remarks}} </span>
                            </p>
                        </div>
                    </div>
                    <section class="font-weight-bold ml-3 marin_zero mobile_elements elements_bg">
                        <div class="row mobile_row">
                            <div class="col-md-2 p-0">
                                <img class="imgStyle" src="{{hotel.HotelPhoto | map: getHotelPhoto}}"
                                    alt="">
                            </div>
                            <div class="col-md-2 p-1 text-center">
                                <p class="cusromBlue m-0">
                                    Check-In:
                                </p>
                                <p class="m-0">
                                    {{hotel.HotelCheckIn | date: 'dd MMM yyyy'}}
                                </p>
                            </div>
                            <div class="col-md-2 p-1 text-center">
                                <p class="cusromBlue m-0">
                                    Check-Out:
                                </p>
                                <p class="m-0">
                                    {{hotel.HotelCheckOut | date: 'dd MMM yyyy'}}
                                </p>
                            </div>
                            <div class="col-md-2 p-1 text-center">
                                <p class="cusromBlue m-0">
                                    Passenger(s):
                                </p>
                                <p class="m-0">
                                    {{pax}}
                                </p>
                            </div>
                            <div class="col-md-2 p-1 text-center">
                                <p class="cusromBlue m-0">
                                    Room(s):
                                </p>
                                <p class="m-0">
                                    {{roomCount}}
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="row m-4 float-right">
                    <div class="col-md-12">

                        <button  *ngIf="refundable == true" type="submit" style="font-size: large;" (click)="reservation()"
                        class="btn btn-lg btn-success btn_confirm">
                        {{'Pay Later'}}
                    </button>  &nbsp;&nbsp;
                        <button type="submit" style="font-size: large;" (click)="intitiatePayment()"
                            class="btn btn-lg btn-success btn_confirm">
                            {{'Pay Now'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-lg-4 mobile_position"
            style="position: sticky;top: 20px; margin-top: 50px; padding-left: 40px; padding-right: 0px; align-self: start;">
            <div class="comon_backbg">
                <h5 class="inpagehed p-2" style="color: #1B9AD4;">Booking Summary</h5>
                <div class="col-md-12">
                    <div class="row font-weight-bold pt-3 pb-3 hotl_details_name">

                        <div class="col-md-4 mpad">
                            <img class="imgStyle" src="{{hotel.HotelPhoto | map: getHotelPhoto}}"
                                alt="">
                        </div>

                        <div class="col-md-8 pl-0">
                            <h5 class="cusromGrey"><strong>{{hotel.HotelName}}</strong> </h5>
                            <ng-template *ngIf="hotel.StarRating === '' then noStar; else stars">
                            </ng-template>
                            <ng-template #noStar>
                                <span class="star_rtng">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </span>
                            </ng-template>
                            <ng-template #stars>
                                <span class="star_rtng">
                                    <i class="fas fa-star star_rtng_clr"
                                        *ngFor="let s of hotel.StarRating | map: getStarArray"></i>
                                    <i class="fas fa-star"
                                        *ngFor="let s of hotel.StarRating | map: getStarArrayRemaining"></i>
                                </span>
                            </ng-template>
                            <p class="cusromGrey">
                                {{hotel.HotelAddress}}
                            </p>
                        </div>
                    </div>

                    <div class="row font-weight-bold pt-3 pb-3 hotl_details_check">
                        <div class="col-md-4 px-3">
                            <p class="cusromgray m-0">
                                Check-In:
                            </p>
                            <p class="cusromBlue m-0">
                                {{hotel.HotelCheckIn | date: 'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="col-md-4 px-3">
                            <p class="cusromgray m-0">
                                Check-Out:
                            </p>
                            <p class="cusromBlue m-0">
                                {{hotel.HotelCheckOut | date: 'dd MMM yyyy'}}
                            </p>
                        </div>

                        <div class="col-md-4 px-y">
                            <p class="cusromgray m-0">
                                No of Nights:
                            </p>
                            <p class="cusromBlue m-0">
                                {{nights}}
                            </p>
                        </div>
                    </div>

                    <div class="row pt-3 pb-3 trooms_desc">
                        <div class="col-md-12 px-3">
                            <h5 *ngFor="let r of room; let i = index">{{r.RoomTypeName}}</h5>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Room Type:
                                    </span>
                                </div>

                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right" *ngFor="let r of room; let i = index">
                                        {{r.RoomTypeName}}
                                    </span>
                                </div>
                            </div>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Adult(s):
                                    </span>
                                </div>
                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right">
                                        {{adultCount}}
                                    </span>
                                </div>
                            </div>

                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        No of Children:
                                    </span>
                                </div>

                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right">
                                        {{childCount}}
                                    </span>
                                </div>
                            </div>

                            <div class="clearfix"></div>


                        </div>
                    </div>
                    <div class="row trooms_desc pt-3 pb-3">
                        <div class="col-md-12 px-3">
                            <h5>Your Price Summary</h5>
                            <div class="clearfix"></div>
                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Price:
                                    </span>
                                </div>
                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right ">
                                        {{hotel.Currency}} {{totalFare + discountAmount - Convenience | number:'1.1-2'}}
                                    </span>
                                </div>

                            </div>
                            <div class="clearfix"></div>

                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Discount:
                                    </span>
                                </div>

                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right ">
                                   {{hotel.Currency}} {{discountAmount | number:'1.1-2'}}
                                    </span>
                                </div>
                            </div>
                            <div class="valign-wrapper mt-1 mb-1">
                                <div class="col-md-6 col-6 nopad">
                                    <span class="cusromBlue m-0">
                                        Convenience Fee:
                                    </span>
                                </div>

                                <div class="col-md-6 col-6 nopad text-right">
                                    <span class="m-0 pull-right ">
                                        {{hotel.Currency}} {{Convenience}}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <h4 class="totel_price text-right">
                        Total: {{hotel.Currency}} {{totalFare | number:'1.1-2'}}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Payment popup -->
<!-- <div class="modal" id="paymentModal" tabindex="-1" role="dialog" aria-labelledby="paymentModalLabel" aria-hidden="true"
    [style.display]="showPaymentDetails ? 'block' : 'none'">
    <div class="modal-dialog" role="document" style="max-width: 600px">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="paymentModalLabel">Payment methods</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="paymentForm">
                    <div class="cc-selector-2">
                        <div class="row">
                            <div class="col-md-3 col-4 mobile_pad7" *ngFor="let paymentMethod of paymentGateways">
                                {{paymentMethod?.remarks | json}}
                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='wallet'">
                                    <label style="width: 46px;" class="drinkcard-cc wallet" for="wallet">
                                    </label>
                                    <span class="payment_label">
                                        <input id="wallet" type="radio" name="paymentMethod" value="wallet" formControlName="paymentMethod" /> {{paymentMethod?.remarks}}
                                    </span>
                                </span>
                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='nagad'">
                                    <label class="drinkcard-cc nagad" for="nagad"></label>
                                    <span class="payment_label">
                                        <input id="nagad" type="radio" name="paymentMethod" value="nagad" formControlName="paymentMethod" /> {{paymentMethod?.remarks}}
                                    </span>
                                </span>
                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='bkash'">
                                    <label class="drinkcard-cc bKash" for="bKash"></label>
                                    <span class="payment_label">
                                        <input id="bKash" type="radio" name="paymentMethod" value="bKash" formControlName="paymentMethod" /> {{paymentMethod?.remarks}}
                                    </span>
                                </span>
                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='sslcommerz'">
                                    <label style="width: 100%; background-position: center;" class="drinkcard-cc sslCommerz" for="sslCommerz"></label>
                                    <span class="payment_label">
                                        <input id="sslCommerz" type="radio" name="paymentMethod" value="sslCommerz" formControlName="paymentMethod" />
                                        {{paymentMethod?.remarks}}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <small class="error text-danger col-xs-12 col-12" style="margin-bottom:10px; display:block;"
                        *ngIf="hasError('paymentMethod', 'required');">
                        Please select the payment type* <br>
                    </small>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="paysubmit" (click)="onBooking(hotel.AppReference)">Confirm</button>
            </div>
        </div>
    </div>
</div> -->
</div>
<ngx-loading [show]="loading"
    [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
    [template]="loadingTemplate"></ngx-loading>
